/**
 * 匿名コンサルホットライン相談日程再申し込みの共通文言
 */
export const hotlineConsultantReorderText = {
    /**
     * 項目の名前
     */
    label: {
        description: () => '相談内容',
        interviewRequestedAt: () => '相談希望日',
        interviewRequestedFromAt: () => '相談希望開始日',
        interviewRequestedToAt: () => '相談希望終了日',
        professional: () => '担当コンサルタント',
        requestDeadlineAt: () => '回答期限',
    },
};
